import { provider as Auth0SSOProvider } from './auth0';
import { provider as Oauth2SSOProvider } from './oauth2';

export const getSSOProvider = platform => {
  switch (platform) {
    case 'auth0':
      return Auth0SSOProvider;
    case 'oauth2':
      return Oauth2SSOProvider;
    default:
      return null;
  }
};

export const isSSOPlatformSupported = platform => {
  const provider = getSSOProvider(platform);
  return provider !== null;
};
